import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import RoleRoute from '@BUP/routes/RoleRoute'
import CoursePage from '@BUP/pages/Course'

const CourseNavigation = () => {
  return (
    <Routes>
      <Route
        path='/'
        element={
          <RoleRoute name='CoursePage'>
            <CoursePage />
          </RoleRoute>
        }
      />
      <Route
        path='*'
        element={<Navigate to='/' />}
      />
    </Routes>
  )
}

export default CourseNavigation
